window.PopupStorage = {

    STORAGE_KEY: "maisa_popup_seen",

    SUBSCRIBED_KEY: "maisa_subscribed",


    setLastShown(){

        localStorage.setItem(
            this.STORAGE_KEY,
            Date.now()
        );

    },


    canShow(){

        const lastShown =
        localStorage.getItem(
            this.STORAGE_KEY
        );

        if(!lastShown){

            return true;

        }

        const sevenDays =
        7 * 24 * 60 * 60 * 1000;

        return (
            Date.now() -
            Number(lastShown)
        ) >= sevenDays;

    },


    setSubscribed(){

        localStorage.setItem(
            this.SUBSCRIBED_KEY,
            "true"
        );

    },


    isSubscribed(){

        return localStorage.getItem(
            this.SUBSCRIBED_KEY
        ) !== null;

    }

};